/*
 * Copyright (c) 2025.
 * This code and its derivatives belong to BETICA LTD and may not be copied, reproduced, amended or used in any way without the permission of BETICA LTD
 * @author torrejonv
 *
 */

export const CMS_CONFIG_TYPE_ACCOUNTS = "ACCOUNTS";
export const CMS_CONFIG_TYPE_APPEARANCE = "APPEARANCE";
export const CMS_CONFIG_TYPE_BETRADAR_VIRTUAL = "BETRADAR_VIRTUAL";
export const CMS_CONFIG_TYPE_BETTING = "BETTING";
export const CMS_CONFIG_TYPE_BRAND_DETAILS = "BRAND_DETAILS";
export const CMS_CONFIG_TYPE_BRAND_LOGOS = "BRAND_LOGOS";
export const CMS_CONFIG_TYPE_KIRON_VIRTUAL = "KIRON_VIRTUAL";
export const CMS_CONFIG_TYPE_RESULTS = "RESULTS";
export const CMS_CONFIG_TYPE_SPORTS_BOOK = "SPORTSBOOK";
